





























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Document } from '@/model/document2/document';
import { InsertionData } from '@/model/document2/insertionData/insertionData';

import * as def from "@/definitions";

import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";

@Component({
  components: {
    DropdownList,
    ArrowDown,
    ArrowRight
  }
})
export default class TableCell extends Vue {

    @Prop()
    private document!: Document;

    //-----開閉のアニメーション-----//
    openStatus = {
        opend: true
    };

    tableCellContentsOpenAnimate = false;
    tableCellContentsCloseAnimate = false;

    open() 
    {
        if (this.openStatus.opend) {
            this.tableCellContentsCloseAnimate = true;
            setTimeout(() => {
                this.tableCellContentsCloseAnimate = false;
                this.tableCellContentsOpenAnimate = false;
                this.openStatus.opend = false;
            }, 200);
        } else {
            this.openStatus.opend = true;
            this.tableCellContentsOpenAnimate = true;
            setTimeout(() => {
                this.tableCellContentsOpenAnimate = false;
            }, 250);
        }
    }
    //-----開閉のアニメーション-----//

    // 行追加
    private insertRow(direction : string)
    {
        this.$emit("doCommand", "insertRow", { direction : direction });
    }

    // 列追加
    private insertColumn(direction : string)
    {
        this.$emit("doCommand", "insertColumn", { direction : direction });
    }

    // 行削除
    private deleteRow()
    {
        this.$emit("doCommand", "deleteRow", null);
    }

    // 列削除
    private deleteColumn()
    {
        this.$emit("doCommand", "deleteColumn", null);
    }

    // 1行目を列名にする
    private get isFirstRowAsColumnName()
    {
        return this.document.insertionData.isFirstRowAsColumnName;
    }
    
    private setFirstRowAsColumnName(enable : boolean)
    {
        this.$emit("doCommand", "setFirstRowAsColumnName", { enable : enable });
    }

    //-----configcolor-----//
    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
    private get userConfigFontColor(){
        var style = {
            color : this.userConfigColor
        };
        return style;
    }
    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }
    //-----configcolor-----//
}
